export const KortGridCell = ({ children, ...props }) => (
  <div {...props} className="xdl-cell xdl-cell--4-col">
    {children}
  </div>
);
